import * as services from '@api';
import { isType } from '@src/utils';

export async function list(rootStore: object, param: object) {
  const params = getQueryParams(rootStore, param)
  let loadParams = { params: params?.query, data: params?.data };
  this?.showProgress?.()
  try {
    // rootStore.pageStore?.startLoading?.();
    // beforeListHook
    if (isType(this.beforeLoadListHook, 'Function')) {
      loadParams = await this.beforeLoadListHook(rootStore, loadParams);
    }
    // console.log('>>>', JSON.stringify(loadParams))疯狂点击查询条件查询条件不一致
    let listRes = await services.list(loadParams)
    // let time = Math.floor(Math.random() * (5000 - 1000 + 1))
    // console.log('显示对话框了-time', time);
    // await wait(1000); //模拟等待时间

    // afterListHook
    if (isType(this.afterLoadListHook, 'Function')) {
      listRes = await this.afterLoadListHook(rootStore, listRes);
    }
    return listRes
  } catch (error) {
    rootStore.utils.message.danger(error?.message);
    return Promise.reject(error);
  } finally {
    // console.timeEnd('显示对话框了')
    // 隐藏进度条
    this?.hideProgress?.()
  }
}
function wait(ms) {
  return new Promise(function(resolve) {
    setTimeout(resolve, ms);
  });
}

/**
 * 构建list接口请求参数
 * @param rootStore
 * @param param
 * @returns
 */
function getQueryParams(rootStore: object, meta: object) {
  const filterName = meta?.filter
  const pagingName = meta?.paging
  const filter = rootStore[filterName];
  const paging = rootStore[pagingName];
  const conditions = filter?.getQueryCondition()
  const pageInfo = paging?.getPageInfo();
  const page = {
    pageIndex: pageInfo?.pageIndex,
    pageSize: pageInfo?.pageSize,
    totalCount: meta?.pagingTag ? -1 : pageInfo?.total
  }
  const data = {
    page: !paging ? {} : page
  };
  data.extraCondition = { ...conditions }
  const query = {
    ...rootStore.pageStore.query,
    billnum: meta.billNo || rootStore.pageStore.params.billNo,
    busiObj: meta.busiObj || rootStore.pageStore.query.busiObj,
    datasource: meta?.dataSourceAlias
  }
  return { query, data }
}
